module.exports = __webpack_public_path__ + "img/close.3264ec28.svg";